
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  categories: [],
  selectedCategoryIndex: null,
  loadedTemplateId: null
};

const categorySlice = createSlice({
  name: 'category',
  initialState,
  reducers: {
    selectCategory: (state, action) => {
      state.selectedCategoryIndex =
        state.selectedCategoryIndex === action.payload ? null : action.payload;
    },
    addElement: (state, action) => {
      const { categoryIndex, element } = action.payload;

      if (state.categories[categoryIndex]) {
        const newId = Date.now();
        const newElement = {
          id: newId,
          ...element,
          name: element.name || `New Element ${state.categories[categoryIndex].elementlist.length + 1}`,
          quantity: element.quantity,
          rate: element.rate,
          grossvalue: element.grossvalue,
          element: element.element,
          cost_period: element.cost_period,
          element_remarks: element.element_remarks,
          cost_maintenance: element.cost_maintenance,
          wi_rate: element.wi_rate,
          cost_margin: element.cost_margin,
          cost_escalation_percentage: element.cost_escalation_percentage,
          cost_escalation: element.cost_escalation,
          margin_rate_percentage: element.margin_rate_percentage,
          cost_with_buffer_month: element.cost_with_buffer_month,
          capex_maintenance: element.capex_maintenance,
          cost_buffer: element.cost_buffer,
          basic_cost_value: element.basic_cost_value,
          cost_without_buffer_month: element.cost_without_buffer_month,
          buffer_rate: element.buffer_rate,
          gross_value: element.gross_value,
          capex_cost_interest: element.capex_cost_interest,
          cost_with_buffer_period: element.cost_with_buffer_period,
          capex_interest_rate_percentage: element.capex_interest_rate_percentage,
          cost_insurance: element.cost_insurance,
          cost_without_buffer_period: element.cost_without_buffer_period,
          capex_insurance_percentage: element.capex_insurance_percentage,
          cost_wi: element.cost_wi
        };
        state.categories[categoryIndex].elementlist.push(newElement);
      }
    },
    updateElement: (state, action) => {
      const { categoryIndex, elementIndex, element } = action.payload;

      if (state.categories[categoryIndex]?.elementlist) {
        state.categories[categoryIndex].elementlist[elementIndex] = element;
      }
    },
    deleteElement: (state, action) => {
      const { categoryIndex, elementIndex } = action.payload;
      if (state.categories[categoryIndex]) {
        state.categories[categoryIndex].elementlist.splice(elementIndex, 1);
      }
    },
    setCategories: (state, action) => {
      const incoming = action.payload;

      console.log("📥 Incoming categories payload:", JSON.stringify(incoming, null, 2));

      state.categories = incoming.map(incomingCategory => {
        const existing = state.categories.find(c => c.categoryId === incomingCategory.categoryId);

        const preservedElementlist = Array.isArray(incomingCategory.elementlist) && incomingCategory.elementlist.length > 0
          ? incomingCategory.elementlist.map(e => ({ ...e }))
          : existing?.elementlist ?? [];

        const result = {
          categoryId: incomingCategory.categoryId,
          categoryCode: incomingCategory.categoryCode,
          categoryName: incomingCategory.categoryName,
          elementlist: preservedElementlist
        };

        console.log("🔁 Processed category:", result);
        return result;
      });

      console.log("✅ Final categories stored in state:", JSON.stringify(state.categories, null, 2));
    },
    resetCategories: (state) => {
      state.categories = [];
      state.selectedCategoryIndex = null;
      state.loadedTemplateId = null;
    },
    setLoadedTemplateId: (state, action) => {
      state.loadedTemplateId = action.payload;
    },
    pasteCategoryElements: (state, action) => {
      const { categoryIndex, elements } = action.payload;
      if (state.categories[categoryIndex] && Array.isArray(elements)) {
        const newElements = elements.map((el, idx) => ({
          ...el,
          id: Date.now() + idx
        }));
        state.categories[categoryIndex].elementlist = [
          ...state.categories[categoryIndex].elementlist,
          ...newElements
        ];
      }
    },
  }
});

export const {
  selectCategory,
  addElement,
  updateElement,
  deleteElement,
  setCategories,
  resetCategories,
  setLoadedTemplateId,
  pasteCategoryElements
} = categorySlice.actions;

export default categorySlice.reducer;